<div class="geo-filter">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="skeleton-columns">
      <div class="skeleton-column">
        <div class="skeleton-title">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-search-bar">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-list">
          <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
            <div class="skeleton-checkbox"><div class="skeleton-shimmer"></div></div>
            <div class="skeleton-text" [style.width.%]="50 + (i * 7) % 30"><div class="skeleton-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="skeleton-column">
        <div class="skeleton-title">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-search-bar">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-list">
          <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
            <div class="skeleton-checkbox"><div class="skeleton-shimmer"></div></div>
            <div class="skeleton-text" [style.width.%]="60 + (i * 11) % 25"><div class="skeleton-shimmer"></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Geography Columns -->
  <div class="geography-columns" *ngIf="!isLoading">
      <!-- States Column -->
      <div class="geography-column">
        <div class="column-title">States</div>
        <div class="search-wrapper">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input type="text"
                 class="search-input"
                 placeholder="Search states"
                 [value]="stateSearchTerm"
                 (input)="onStateSearchChange($event)">
          <svg *ngIf="stateSearchTerm" class="clear-search-icon" (click)="clearStateSearch()" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="geography-items-container">
          <div class="geography-item"
               *ngFor="let state of getFilteredItems(states, stateSearchTerm)"
               (click)="toggleSelection(state)">
            <div class="checkbox" [class.checked]="state.selected">
              <svg *ngIf="state.selected" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="item-name">{{ state.name }}</span>
          </div>
          <div class="no-results" *ngIf="getFilteredItems(states, stateSearchTerm).length === 0 && stateSearchTerm">
            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="no-results-text">No results found</span>
          </div>
        </div>
      </div>

      <!-- CBSAs Column -->
      <div class="geography-column">
        <div class="column-title">CBSAs</div>
        <div class="search-wrapper">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input type="text"
                 class="search-input"
                 placeholder="Search CBSAs"
                 [value]="cbsaSearchTerm"
                 (input)="onCbsaSearchChange($event)">
          <svg *ngIf="cbsaSearchTerm" class="clear-search-icon" (click)="clearCbsaSearch()" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="geography-items-container">
          <div class="geography-item"
               *ngFor="let cbsa of getFilteredItems(cbsas, cbsaSearchTerm)"
               (click)="toggleSelection(cbsa)">
            <div class="checkbox" [class.checked]="cbsa.selected">
              <svg *ngIf="cbsa.selected" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="item-name">{{ cbsa.name }}</span>
          </div>
          <div class="no-results" *ngIf="getFilteredItems(cbsas, cbsaSearchTerm).length === 0 && cbsaSearchTerm">
            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="no-results-text">No results found</span>
          </div>
        </div>
      </div>

    </div>

</div>
